var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "mb-4 px-5" },
    [
      _vm.source.error
        ? _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "10px 5px" } },
            [
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", round: "", small: "" },
                      on: { click: _vm.handleClick }
                    },
                    [
                      _c("v-icon", [_vm._v("refresh")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticStyle: { "text-transform": "none" } },
                        [_vm._v(_vm._s(_vm.$t("TICKET_RETRY_BUTTON")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticStyle: { "font-size": "18px", color: "red" } },
                [_vm._v("error_outline")]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-style": "italic", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.source.error))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm.coIsOwner ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c("v-hover", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var hover = ref.hover
                  return _c(
                    "v-card",
                    {
                      staticClass: "message__container",
                      attrs: { color: _vm.coContainerColor }
                    },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "message__container--owner",
                              class: _vm.coTextColor,
                              attrs: { column: "" }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFullName(_vm.coCreatedBy)
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.source.action_type ===
                          _vm.dtActionTypes.Attachment
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "min-height": "80px",
                                    "min-width": "100px"
                                  }
                                },
                                [
                                  _vm.source.attachment.media.type ===
                                  _vm.dtActionTypes.AttachmentImage
                                    ? _c("div", [
                                        _c("img", {
                                          directives: [
                                            { name: "img", rawName: "v-img" }
                                          ],
                                          staticClass: "message__image",
                                          attrs: {
                                            src:
                                              _vm.source.attachment.media.link
                                          }
                                        })
                                      ])
                                    : _vm.source.attachment.media.type ===
                                      _vm.dtActionTypes.AttachmentVideo
                                    ? _c("div", [
                                        _c(
                                          "video",
                                          {
                                            staticClass: "message__video",
                                            attrs: { controls: "" }
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src:
                                                  _vm.source.attachment.media
                                                    .link
                                              }
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("LBL_HTML5_REQUIRED")
                                                ) +
                                                "\n                "
                                            ),
                                            _c("v-icon", [_vm._v("movie")])
                                          ],
                                          1
                                        )
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                "mt-1": "",
                                                "mb-1": "",
                                                "text-xs-center": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    "text-decoration": "none"
                                                  },
                                                  attrs: {
                                                    href:
                                                      _vm.source.attachment
                                                        .media.link,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: _vm.coIsOwner
                                                          ? "white"
                                                          : "primary",
                                                        size: "5vh"
                                                      }
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "secondary--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.documentType(
                                                            _vm.source
                                                              .attachment.media
                                                              .link
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    class: _vm.coIsOwner
                                                      ? "white--text"
                                                      : "primary--text",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.source.attachment
                                                          .media.name
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                ]
                              )
                            : _vm.source.message
                            ? [
                                _vm.source.updating && _vm.upMsgOpen
                                  ? [
                                      _c("v-textarea", {
                                        staticClass: "white mb-4",
                                        attrs: {
                                          color: "black",
                                          "auto-grow": "",
                                          rows: "1",
                                          "hide-details": "",
                                          outline: "",
                                          solo: "",
                                          "background-color": "black",
                                          disabled: _vm.updateMsgLoading,
                                          loading: _vm.updateMsgLoading
                                        },
                                        model: {
                                          value: _vm.newText,
                                          callback: function($$v) {
                                            _vm.newText = $$v
                                          },
                                          expression: "newText"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            bottom: "4px",
                                            right: "44px"
                                          },
                                          attrs: {
                                            flat: "",
                                            icon: "",
                                            color: "green",
                                            absolute: "",
                                            loading: _vm.updateMsgLoading
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.sendUpdateMessage(_vm.source)
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("check")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            bottom: "4px",
                                            right: "84px"
                                          },
                                          attrs: {
                                            flat: "",
                                            icon: "",
                                            color: "red",
                                            absolute: "",
                                            loading: _vm.updateMsgLoading
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.closeUpdate(_vm.source)
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      )
                                    ]
                                  : _c("div", { class: _vm.coTextColor }, [
                                      _c("div", {
                                        staticClass:
                                          "message__container--message",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.source.message.message +
                                              _vm.labelMsgIsUpdated(_vm.source)
                                          )
                                        }
                                      })
                                    ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          hover &&
                          _vm.coIsOwner &&
                          !_vm.source.temporaryCreatedAt
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: { bottom: "4px", right: "4px" },
                                  attrs: {
                                    id: "btn_msg",
                                    flat: "",
                                    icon: "",
                                    color: "white",
                                    absolute: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showMenu = true
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("more_horiz")])],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-menu",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "90px",
                                right: "40px"
                              },
                              attrs: {
                                attach: "#btn_msg",
                                left: "",
                                bottom: ""
                              },
                              model: {
                                value: _vm.showMenu,
                                callback: function($$v) {
                                  _vm.showMenu = $$v
                                },
                                expression: "showMenu"
                              }
                            },
                            [
                              _c(
                                "v-list",
                                _vm._l(_vm.itemsMenu(_vm.source), function(
                                  item,
                                  index
                                ) {
                                  return _c(
                                    "v-list-tile",
                                    {
                                      key: index,
                                      on: {
                                        click: function($event) {
                                          item.action(_vm.source)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(_vm._s(item.title))
                                      ])
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _vm.coIsOwner ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c("message-time-notif-status", { attrs: { source: _vm.source } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2332797a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2332797a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message-item/template.html
// module id = null
// module chunks = 